import { legacyPlugins } from "/home/runner/work/1/s/frontend/node_modules/@unhead/vue/dist/legacy.mjs";
export default {
  disableDefaults: true,
  plugins: legacyPlugins,
}